module.exports = __webpack_public_path__ + "static/media/EntirosIntegrations_MASTER.448f921e.mp4";